import "./login.css";
import "react-toastify/dist/ReactToastify.css";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaRegUser, FaLock } from "react-icons/fa6";
import { PiEye, PiEyeClosed } from "react-icons/pi";
import { loginModel } from "../../models/login.model.js";
import { validateUser } from "../../utils/validations.js";
import { ToastContainer, toast } from "react-toastify";
import { useWindowSize } from "react-hooks-window-size";

import axios from "axios";
import route from "../../config.json";
import TokenService from "../../services/token.service.js";
import CardinalstoneLogo from "../../assets/CardinalStone Logo.svg";
import Typewriter from "typewriter-effect";
import LightLoader from "../../components/Loader/LightLoader/LightLoader.jsx";
import secureLocalStorage from "react-secure-storage";

function Login() {
	const screenSize = useWindowSize();
	const desktopView = screenSize.width > 968;
	const mobileView = screenSize.width < 968;
	const navigate = useNavigate();
	const [user, setUser] = useState(loginModel);
	const [passwordShown, setPasswordShown] = useState(false);
	const [loading, setLoading] = useState(false);

	const defaultDestination = "/dashboard/calendar";
	const customId = "toast-custom-id";

	const showToastWarning = (warning) => {
		toast.warning(warning, {
			position: toast.POSITION.TOP_RIGHT,
			toastId: customId,
			autoClose: 2000,
			hideProgressBar: true,
		});
	};

	const showToastError = (error) => {
		toast.error(error, {
			position: toast.POSITION.TOP_RIGHT,
			toastId: customId,
			autoClose: 1500,
			hideProgressBar: true,
		});
	};

	const handleChange = (e) => {
		e.preventDefault();
		const { name, value } = e.target;
		setUser((prevState) => ({ ...prevState, [name]: value }));
	};

	const togglePasswordVisibility = () => {
		setPasswordShown(passwordShown ? false : true);
	};

	const handleLoginUser = async (e) => {
		e.preventDefault();
		setLoading(true);

		if (validateUser(user)) {
			showToastWarning("Please enter your username and password");
			setLoading(false);
			return;
		}

		try {
			const response = await axios.post(`${route.ApiUrl}/api/v1/login`, user);

			const resData = response?.data?.data;

			const token = resData.token;
			const groups = resData?.groups;

			const userData = {
				name: resData?.fullName,
				email: resData?.email,
				username: resData?.username,
				groups: groups,
				department: resData?.department,
				phone: resData?.phone || "N/A",
			};

			TokenService.setToken(token);
			TokenService.setUser(userData);
			secureLocalStorage.setItem("eventMode", "internal");

			navigate(
				desktopView
					? defaultDestination
					: mobileView
						? "/dashboard/event-list"
						: defaultDestination
			);

			setLoading(false);
		} catch (error) {
			if (error?.code === "ERR_NETWORK") {
				showToastWarning(`${error?.message} 😢`);
			} else {
				showToastError(error?.response?.data?.message);
			}
			setLoading(false);
		}
	};

	useEffect(() => {
		document.title = "Event Dashboard | Login";

		const queryString = new URLSearchParams(window.location.search);
		const user = JSON.parse(decodeURIComponent(queryString.get("user")));
		const token = decodeURIComponent(queryString.get("token"));

		if (token && user) {
			const userData = {
				name: user?.name,
				email: user?.email,
				username: user?.username,
				groups: user?.groups,
				department: user?.department,
				phone: user?.phone || "N/A",
			};

			TokenService.setToken(token);
			TokenService.setUser(userData);
			secureLocalStorage.setItem("eventMode", "external");

			window.location = defaultDestination;
		}
	}, []);

	return (
		<>
			<main className="login">
				<div className="login_container">
					<div className="login_left_div">
						<h1>
							<Typewriter
								onInit={(typewriter) => {
									typewriter
										.typeString("Event Creation")
										.pauseFor(2000)
										.deleteChars(8)
										.typeString("Management")
										.pauseFor(2000)
										.deleteChars(10)
										.typeString("Reminder")
										.pauseFor(2000)
										.deleteChars(8)
										.typeString("Dashboard")
										.start();
								}}
							/>
						</h1>
						<p className="slide-in-left">Portal</p>
					</div>
					<div className="login_right_div">
						<div className="login_right_logo_div">
							<img
								className="login-img"
								src={CardinalstoneLogo}
								alt="CardinalStone"
							/>
						</div>
						<div className="login_right_header_div">
							<h1>Welcome</h1>
							<p>Please login here</p>
						</div>
						<form className="login_right_form" onSubmit={handleLoginUser}>
							<div className="form_group">
								<FaRegUser className="login_input_icon" />
								<input
									type="text"
									name="username"
									id="username"
									placeholder="Username"
									className="form_input"
									value={user.username}
									onChange={handleChange}
								/>
							</div>
							<div className="form_group">
								<FaLock className="login_input_icon" />
								<input
									type={passwordShown ? "text" : "password"}
									name="password"
									id="password"
									placeholder="Password"
									className="form_input password"
									value={user.password}
									onChange={handleChange}
								/>
								<i onClick={togglePasswordVisibility}>
									{passwordShown === false ? (
										<PiEyeClosed className="login_password_eye" />
									) : (
										<PiEye className="login_password_eye" />
									)}
								</i>
							</div>
							<button className="login_right_form_button" type="submit">
								{loading ? <LightLoader /> : "Login"}
							</button>
						</form>
					</div>
				</div>
			</main>

			<ToastContainer />
		</>
	);
}

export default Login;
